import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { SocialCoachSession } from "@/services/bedrock/dtos";

const SESSION_SERVICE = `${Constants.API_URL}/bedrock/me`;

export class SessionServices {
  @scCatchServiceException()
  static async getMe(): Promise<SocialCoachSession> {
    const { data } = await axios.get<SocialCoachSession>(SESSION_SERVICE);
    return data;
  }
}
